import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { paragraphLarge } from '@helpers/typography';
import ArticleCardStyles from '@stories/Components/Cards/ArticleCard/ArticleCard.styles';
import FiltersStyles from '@stories/Components/Listings/Filters/Filters.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const FiltersWrapper = styled(SectionWrapper) `
  --sectionSpacing: 32px;

  background-color: ${brand.primary.blueGrey};
  /* overflow: hidden; */
  z-index: 6;

  ${FiltersStyles.Container} {
    margin: 0;
  }
`;
const Container = styled(SectionWrapper) `
  overflow: hidden;
`;
const PagingSummary = styled.div `
  ${fonts.apparat.medium};

  font-size: ${fluid(18, 20)};
  line-height: ${fluid(28, 30)};
  text-align: center;

  > span {
    ${fonts.apparat.semiBold};
  }

  &[data-position='top'] {
    margin: 0 0 ${fluid(32, 48)};
  }

  &[data-position='bottom'] {
    margin: ${fluid(30, 64)} 0 0;
  }
`;
const ResultsContainer = styled.div `
  ${baseGrid};

  row-gap: var(--gutterWidth);
  scroll-margin: var(--scrollOffset, 0px) 0 0;

  ${ArticleCardStyles.Container} {
    grid-column: span 24;

    @media ${from(Device.Tablet)} {
      grid-column: span 12;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: span 8;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: span 6;
    }
  }
`;
const NoResultsText = styled.p `
  ${paragraphLarge};

  grid-column: span 24;
  text-align: center;
  margin-top: ${fluid(16, 24)};
`;
const ArticleListingStyles = {
    Container,
    NoResultsText,
    ResultsContainer,
    FiltersWrapper,
    PagingSummary,
};
export default ArticleListingStyles;
